import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var activeGuidelineStyle = function activeGuidelineStyle(guideline) {
  return _objectSpread(_objectSpread({}, guideline), {}, {
    active: true,
    show: true
  });
};
export var getGuidelinesWithHighlights = function getGuidelinesWithHighlights(gap, maxGap, activeGuidelineKeys, guidelines) {
  if (activeGuidelineKeys.length) {
    return guidelines.map(function (guideline) {
      if (activeGuidelineKeys.includes(guideline.key) && gap < maxGap) {
        return activeGuidelineStyle(guideline);
      }
      return guideline;
    });
  } else {
    return guidelines;
  }
};